@use 'src/global/variables.scss' as var;

:host(.closed) {
  // Todo Retest if still true. this.isOpen && <c-dialog> requires this.closeButton.focus() to be in timeout
  // Have to use visibility hidden instead of display block or hidden attribute, because of Mac's VoiceOver
  // Screen Reader, which does not move focus into the dialog otherwise.
  visibility: hidden;
}
:host {
  z-index: 1000;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(111, 111, 111, 0.5);
  flex-direction: column;
  // The same background as the header is needed for IE11,
  // where there is a small gap between the header and the ba-chatbot-welcome/message-screen,
  // in which the background color below will shine through, resulting in a white line
  // if we don't set it here. Setting the background-color here, then leads to an issue on Safari, where the
  // background-color shines through around the input element at the bottom of the chatbot,
  // so we need to set the white background-color there
  background-color: var.$message-screen-background-color;

  position: fixed;
  max-width: 100vw;
  max-height: 100vh;
  height: 700px;
  width: 480px;
  bottom: var.$bot-position;
  right: var.$bot-position;
  font-size: 1em;
}

@media (max-width: 767px), (min-height: 367px) and (max-height: 800px) {
  :host {
    bottom: 0px;
    display: flex;
  }
}

// max-width: 768px is smallest iPad size
@media (max-width: 767px), (max-height: 366px) {
  :host {
    // 100vh does not work because of iPhones and the fix suggested here is not working either:
    // https://stackoverflow.com/questions/37112218/css3-100vh-not-constant-in-mobile-browser
    // https://css-tricks.com/css-fix-for-100vh-in-mobile-webkit/
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: auto;
    height: auto;
    border-radius: 0;
  }
}
